import React from "react";
import { 
    TextField, 
    Button, 
    FormControl, 
    InputLabel, 
    Select, 
    OutlinedInput, 
    MenuItem, 
    Checkbox, 
    FormControlLabel
} from '@mui/material';
import EventStatus, { EventStatuses } from '../../../models/EventStatus';
import BmwEventNumbers from '../../../models/BmwEventNumbers';
import DownloadFile from './DownloadFile'
import EventOptionAvailabilityTypes from '../../../models/EventOptionAvailabilityTypes';
import { UserRoles } from '../../../models/UserRoles';
import { DatePicker } from '@mui/x-date-pickers';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Constants from '../../../models/Constants' 
import { Chip } from '@mui/material'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload'

const GeneralEventOptions = (props: any) => {

    let statuses: JSX.Element[] = (props.statuses as EventStatus[]).map(x => {
        return <MenuItem key={x.id} value={x.id}>{x.description}</MenuItem>
    })

    let bmwNumbers: JSX.Element[] = (props.bmwNumbers as BmwEventNumbers[]).map(x => {
        return <MenuItem key={x.id} value={x.id}>{x.bmwnumber} - {x.description}</MenuItem>
    })

    let availabilityTypes: JSX.Element[] = (props.availabilityTypes as EventOptionAvailabilityTypes[]).map(x => {
        return <MenuItem key={x.id} value={x.id}>{x.description}</MenuItem>
    })

    const dateFromError = !props.eventRequiredFields.eventFrom || 
                            ((props.value.eventFrom instanceof Date ) && new Date(props.value.eventFrom).setHours(0) > new Date(props.value.eventTo).setHours(0));
    
    const dateToError = !props.eventRequiredFields.eventTo || 
                            ((props.value.eventTo instanceof Date ) && new Date(props.value.eventTo).setHours(0) < new Date(props.value.eventFrom).setHours(0))
   // console.log('dateFromError', dateFromError, 'dateToError', dateToError);

    return (
        <div className='card'>
            <div className='card-header'>
                Allgemeine Veranstaltungsoptionen
            </div>
            <div className='card-body'>
            {
                (props.role === UserRoles[UserRoles.Administrator] || props.role === UserRoles[UserRoles.TeilAdministrator])  &&
                <div className='row mb-3'>
                    <Button 
                        className='ml-2 width-auto' 
                        variant='outlined' 
                        color='primary'
                        onClick={() => props.showCancelModal()}>
                        Absagen
                    </Button>
                        {
                            (props.role === UserRoles[UserRoles.Administrator] && props.value.eventStatusId === EventStatuses.Lohnabrechnung) &&
                            <Button
                                className='ml-2 width-auto'
                                variant='outlined'
                                color='primary'
                                onClick={() => props.generateInvoice()}>
                                Abrechnen
                            </Button>
                        }
                    <Button 
                        className='ml-2 width-auto' 
                        variant='outlined'
                        color='primary'
                        onClick={() => props.showEmailModal()}>
                        EMAIL
                    </Button>
                    <Button
                        className='ml-2 btnBlue width-auto'
                        variant='contained'
                        color='primary'
                        onClick={() => props.export()}>
                        Excel-Export
                    </Button>
                </div>
            }
                <div className='row'>
                    <div className='col-sm-12'>
                        <TextField 
                            label='Bezeichnung' 
                            name='eventName'
                            style={{ borderColor: 'rgb(0, 155, 229)' }}
                            error={!props.eventRequiredFields.eventName}
                            value={typeof props.value.eventName !== 'undefined' ? props.value.eventName : ''} 
                            onChange={(e:any) => props.change(e)} 
                            fullWidth />
                    </div>
                </div>
                <div className='row mt-3'>
                    {
                        props.value.attachment !== null && props.value.attachment.id > 0 &&
                        <div className='col-sm-2'>
                            <DownloadFile
                                file={props.value.attachment}
                                download={props.downloadAttachment}
                                delete={props.deleteAttachment} />
                        </div>
                    }
                    {
                    (props.value.attachment === null ||
                        props.value.attachment.id <= 0) &&
                        <div className='col-sm-3'>
                            { (props.value.attachment === null || !props.value.attachment.attachmentFilename) &&<Button>
                                <input type="file" onChange={(e:any) => props.changeAttachment(e)} /></Button>
                            }
                            
                             {
                                props.value.attachment != null && props.value.attachment.attachmentFilename &&
                                     <Chip
                                        label={props.value.attachment.attachmentFilename}
                                        clickable
                                        className='btnBlue'
                                        color="primary"
                                        onDelete={ () => props.deleteTempAttachment()}
                                    />
                            }
                        </div>
                    }
                   
                </div>
                <div className='row mt-3'>
                    <div className='col-sm-4'>
                        <DatePicker
                            label='Datum von'
                            value={new Date(props.value.eventFrom)}
                            maxDate={new Date('2100-01-01')}
                            // maxDateMessage='Das Datum sollte nicht nach dem "Datum bis" liegen'
                            onError={(err) => { 
                                return props.switchSaveButton(err !== null && err !== undefined) 
                            }}
                            slotProps={{
                                    textField: {
                                        error: Boolean(dateFromError),
                                        helperText: Constants.DateFormat,
                                },
                                }}
                            onChange={(date: any) => {                          
                                if(date !== null )
                                    props.switchSaveButton(false)
                                let dateValue = date
                                if (dateValue != null && dateValue.setHours !== undefined)
                                    dateValue.setHours(22) 
                                let event = {
                                    target: {
                                        name: 'eventFrom',
                                        value: dateValue
                                    },
                                }
                                props.change(event)
                                props.switchSaveButton(dateFromError)
                            }}
                            format={Constants.DateFormat}
                            // invalidDateMessage='ungültiges Datumsformat'
                        />
                    </div>
                    <div className='col-sm-4'>
                        <DatePicker
                            label='Datum bis'
                            value={new Date(props.value.eventTo)}
                            minDate={props.value.eventFrom !== null ? new Date(props.value.eventFrom) : new Date('1900-01-01')}
                            slotProps={{
                                textField: {
                                     error: Boolean(dateToError),
                                  helperText: Constants.DateFormat,
                                },
                              }}
                            // minDateMessage='Das Datum sollte nicht vor dem "Datum von" liegen'
                            onError={(err) => { 
                                console.log('Datum bis onError: ', err);
                                return props.switchSaveButton(err !== null && err !== undefined) 
                            }}
                            onChange={(date: any) => {
                                console.log('onChange dateToError', dateToError )
                                if(date !== null )
                                    props.switchSaveButton(false)

                                let dateValue = date
                                if (dateValue != null && dateValue.setHours !== undefined)
                                    dateValue.setHours(22) 
                                let event = {
                                    target: {
                                        name: 'eventTo',
                                        value: dateValue
                                    },
                                }
                                props.change(event)
                                props.switchSaveButton(dateToError)

                            }}
                            format={Constants.DateFormat}
                        />
                    </div>
                    <div className='col-sm-4'>
                        
                        <FormControl variant="outlined" fullWidth error={!props.eventRequiredFields.eventStatusId}>
                            <InputLabel htmlFor="outlined-aktiv">  Status </InputLabel>
                            <Select
                                name='eventStatusId'
                                input={
                                    <OutlinedInput id='outlined-aktiv' fullWidth />
                                }
                                onChange={(e:any) => props.change(e)}
                                disabled={!(props.role === UserRoles[UserRoles.Administrator] || props.role === UserRoles[UserRoles.TeilAdministrator])}
                                value={typeof props.value.eventStatusId !== 'undefined' ? props.value.eventStatusId : ''}
                                fullWidth
                            >
                                <MenuItem value="">
                                    <em></em>
                                </MenuItem>
                                {statuses}
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className='col-sm-4'>
                        <FormControl variant="outlined" fullWidth>
                            <InputLabel htmlFor="outlined-aktiv">
                                BMW Nummer
                            </InputLabel>
                            <Select
                                input={
                                    <OutlinedInput id='outlined-aktiv' fullWidth />
                                }
                                name='bmweventNumberId'
                                error={!props.eventRequiredFields.bmweventNumberId}
                                value={typeof props.value.bmweventNumberId !== 'undefined' ? props.value.bmweventNumberId : ''}
                                onChange={(e:any) => props.change(e)}
                                fullWidth
                            >
                                <MenuItem value="">
                                    <em></em>
                                </MenuItem>
                                {bmwNumbers}
                            </Select>
                        </FormControl>
                    </div>
                    <div className='col-sm-4'>
                        <FormControl variant="outlined" fullWidth>
                            <InputLabel htmlFor="outlined-aktiv">
                                Verfügbarkeit
                            </InputLabel>
                            <Select
                                input={
                                    <OutlinedInput id='outlined-aktiv' fullWidth />
                                }
                                name='availabilityId'
                                value={typeof props.value.availabilityId !== 'undefined' ? props.value.availabilityId : '3'}
                                onChange={(e:any) => props.change(e)}
                                fullWidth
                            >
                                {availabilityTypes}
                            </Select>
                        </FormControl>
                    </div>
                    {
                        props.value.eventStatusId == EventStatuses.Abgesagt &&
                        <div className='col-sm-4'>
                            <TextField
                                id="outlined-read-only-input"
                                label="Grund für die Absage"
                                fullWidth
                                margin="normal"
                                value={props.value.cancellationReason}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </div>
                    }
                </div>
                <div className='row mt-3'>
                    <div className='col-sm-4'>
                        <TextField 
                            label='Maximale Teilnehmer'
                            name='maxMembersCount'
                            value={typeof props.value.maxMembersCount !== 'undefined' ? props.value.maxMembersCount : ''}
                            onChange={(e:any) => props.change(e)} 
                            fullWidth />
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className='col-sm-4'>
                        <TextField 
                            label='Maximale Teams' 
                            name='maxTeamsCount'
                            value={typeof props.value.maxTeamsCount !== 'undefined' ? props.value.maxTeamsCount : ''}
                            onChange={(e:any) => props.change(e)}
                            fullWidth />
                    </div>
                    <div className='col-sm-4 offset-sm-4'>
                        <DateTimePicker
                            label='im Web Sichtbar von:'
                            name='webPublishDateFrom'
                            value={new Date(props.value.webPublishDateFrom ? props.value.webPublishDateFrom : new Date())}
                            maxDate={props.value.webPublishDateTo != null ? new Date(props.value.webPublishDateTo) : new Date()}
                            format={Constants.DateTimeFormat}
                            slotProps={{
                                textField: {
                                  helperText: Constants.DateTimeFormat,
                                },
                              }}
                            onError={() => props.switchSaveButton(true)}
                            onChange={(date: any) => {
                                if(date !== null)
                                    props.switchSaveButton(false)

                                let dateValue = date
                                let event = {
                                    target: {
                                        name: 'webPublishDateFrom',
                                        value: dateValue
                                    },
                                }
                                props.change(event)
                            }}
                         />
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className='col-sm-4'>
                        <TextField 
                            label='Minimale Teamgröße'
                            name='minTeamSize'
                            value={typeof props.value.minTeamSize !== 'undefined' ? props.value.minTeamSize : ''}
                            onChange={(e:any) => props.change(e)} 
                            fullWidth />
                    </div>
                    <div className='col-sm-4 offset-sm-4'>
                        <DateTimePicker
                            label='im Web Sichtbar bis:'
                            name='webPublishDateTo'
                            value={new Date(props.value.webPublishDateTo ? props.value.webPublishDateTo : new Date())}
                            format={Constants.DateTimeFormat}
                            slotProps={{
                                textField: {
                                  helperText: Constants.DateTimeFormat,
                                },
                              }}
                            minDate={props.value.webPublishDateFrom != null ? new Date(props.value.webPublishDateFrom) : new Date('1900-01-01')}
                          //  minDateMessage='Das Datum sollte nicht vor dem "im Web Sichtbar von" liegen'
                            onError={() => props.switchSaveButton(true)}
                            onChange={(date: any) => {
                                if(date !== null )
                                    props.switchSaveButton(false)
                                let dateValue = date
                                let event = {
                                    target: {
                                        name: 'webPublishDateTo',
                                        value: dateValue
                                    }
                                }
                                props.change(event)
                            }}
                        //    invalidDateMessage='ungültiges Datumsformat'
                     />
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className='col-sm-4'>
                        <TextField 
                            label='Maximale Teamgröße'
                            name='maxTeamSize'
                            value={typeof props.value.maxTeamSize !== 'undefined' ? props.value.maxTeamSize : ''}
                            onChange={(e:any) => props.change(e)} 
                            fullWidth/>
                    </div>
                    <div className='col-sm-4'>
                        <FormControlLabel control={
                            <Checkbox
                                style={{ color: 'rgb(0, 155, 229)' }}
                                name='memberGenderTypeRequired'
                                checked={typeof props.value.memberGenderTypeRequired != 'undefined' ? JSON.parse(props.value.memberGenderTypeRequired) : false}
                                onChange={(e:any) => {
                                    e.target.value = e.target.checked.toString()
                                    props.change(e)
                                }}
                            />
                        } label="Geschlecht erforderlich" />
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className='col-sm-4'>
                        <FormControlLabel control={
                            <Checkbox
                                style={{ color: 'rgb(0, 155, 229)' }}
                                name='teamLeaderRequired'
                                checked={typeof props.value.teamLeaderRequired != 'undefined' ? JSON.parse(props.value.teamLeaderRequired) : false}
                                onChange={(e:any) => {
                                    e.target.value = e.target.checked.toString()
                                    props.change(e)
                                }}
                            />
                        } label="Teamleiter erforderlich" />
                    </div>
                    <div className='col-sm-4'>
                        <FormControlLabel control={
                            <Checkbox
                                style={{ color: 'rgb(0, 155, 229)' }}
                                name='memberBirthDateRequired'
                                checked={typeof props.value.memberBirthDateRequired != 'undefined' ? JSON.parse(props.value.memberBirthDateRequired) : false}
                                onChange={(e:any) => {
                                    e.target.value = e.target.checked.toString()
                                    props.change(e)
                                }}
                            />
                        } label="Geburtsdatum erforderlich" />
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className='col-sm-4'>
                        <TextField 
                            label='Teampreis' 
                            name='singleTeamPrice'
                            value={typeof props.value.singleTeamPrice !== 'undefined' && props.value.singleTeamPrice !== null ? props.value.singleTeamPrice.toString().replace('.', ',') : ''}
                            onChange={(e:any) => { 
                                e.target.value = e.target.value.replace(',','.')
                                props.change(e)
                            }}
                            fullWidth/>
                    </div>

                    {
                        typeof props.value.memberBirthDateRequired != 'undefined' && JSON.parse(props.value.memberBirthDateRequired) === true &&
                            <div className='col-sm-4'>

                                <FormControlLabel control={
                                    <Checkbox
                                        style={{ color: 'rgb(0, 155, 229)' }}
                                        name='jahrgang'
                                        checked={typeof props.value.jahrgang != 'undefined' ? JSON.parse(props.value.jahrgang) : false}
                                        onChange={(e:any) => {
                                            e.target.value = e.target.checked.toString()
                                            props.change(e)
                                        }}
                                    />
                                } label="Jahrgang für Preisberechnung" />
                            </div>

                    }
                </div>
                <div className='row mt-3'>
                    <div className='col-sm-12'>
                        <TextField 
                            label='Beschreibung'
                            variant='outlined'
                            rows={3}
                            name='eventDescription'
                            value={typeof props.value.eventDescription !== 'undefined' ? props.value.eventDescription : ''} 
                            onChange={(e:any) => props.change(e)}
                            fullWidth 
                            multiline
                            />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GeneralEventOptions